import { Stack, Box } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useTranslation } from 'react-i18next';

export function LoadFailed() {
  const { t } = useTranslation();
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ height: window.innerHeight, backgroundColor: 'rootContainer.background' }}
    >
      <SentimentVeryDissatisfiedIcon sx={{ color: 'rootContainer.color', fontSize: '50px' }} />
      <Box sx={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>{t('errors:noInternet')}</Box>
    </Stack>
  );
}
